var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.errorPage ? 'hasBg' : ''],attrs:{"id":"error-Page"}},[(!_vm.errorPage)?_c('div',{staticClass:"errorTextBox"},[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }